// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".IEiframe[data-v-18a7ffa3]{position:absolute;z-index:-1;top:0;left:0;width:100%;height:100%}.Alert[data-v-18a7ffa3]{width:100%;padding:0}", ""]);
// Exports
module.exports = exports;
